// @flow
import type { ERROR_TYPE, ID_TYPE } from './common';
import type { ROUTE_TYPE } from './routes';
import type { STUDENT_TYPE } from './student';
import type { PARENT_TYPE } from './parents';
import type { CHANGE_STOP_REQUEST_TYPE } from './changeStopRequest';
import type { GATEWAY_TYPE } from './gateways';

export type STUDENTS_FETCH_STARTED_TYPE = {
  type: 'STUDENTS_FETCH_STARTED'
};
export const STUDENTS_FETCH_STARTED = 'STUDENTS_FETCH_STARTED';

export type STUDENTS_FETCH_SUCCEED_TYPE = {
  type: 'STUDENTS_FETCH_SUCCEED',
  payload: {
    entities: {[number]: STUDENT_TYPE},
    order: Array<number>
  }
};
export const STUDENTS_FETCH_SUCCEED = 'STUDENTS_FETCH_SUCCEED';

export type STUDENTS_FETCH_FAILED_TYPE = {
  type: 'STUDENTS_FETCH_FAILED',
  payload: ERROR_TYPE
};
export const STUDENTS_FETCH_FAILED = 'STUDENTS_FETCH_FAILED';

export type STUDENT_FETCH_STARTED_TYPE = {
  type: 'STUDENT_FETCH_STARTED',
  payload: number
};
export const STUDENT_FETCH_STARTED = 'STUDENT_FETCH_STARTED';

export type STUDENT_FETCH_SUCCEED_TYPE = {
  type: 'STUDENT_FETCH_SUCCEED',
  payload: STUDENT_TYPE
};
export const STUDENT_FETCH_SUCCEED = 'STUDENT_FETCH_SUCCEED';

export type STUDENT_FETCH_FAILED_TYPE = {
  type: 'STUDENT_FETCH_FAILED',
  payload: ERROR_TYPE
};
export const STUDENT_FETCH_FAILED = 'STUDENT_FETCH_FAILED';

export type STUDENT_SELECTED_TYPE = {
  type: 'STUDENT_SELECTED',
  payload: number
};
export const STUDENT_SELECTED = 'STUDENT_SELECTED';

export type STUDENT_SELECTION_CLEARED_TYPE = {
  type: 'STUDENT_SELECTION_CLEARED'
};
export const STUDENT_SELECTION_CLEARED = 'STUDENT_SELECTION_CLEARED';

export type STUDENT_DROPPED_TYPE = {
  type: 'STUDENT_DROPPED',
  payload: number
};
export const STUDENT_DROPPED = 'STUDENT_DROPPED';


export type FETCH_STUDENT_PARENTS_STARTED_TYPE = {
  type: 'FETCH_STUDENT_PARENTS_STARTED',
  payload: number
};
export const FETCH_STUDENT_PARENTS_STARTED = 'FETCH_STUDENT_PARENTS_STARTED';


export type FETCH_STUDENT_PARENTS_SUCCEED_TYPE = {
  type: 'FETCH_STUDENT_PARENTS_SUCCEED',
  payload: {
    entities: Array<PARENT_TYPE>,
    order: Array<number>,
  }
};
export const FETCH_STUDENT_PARENTS_SUCCEED = 'FETCH_STUDENT_PARENTS_SUCCEED';

export type FETCH_STUDENT_PARENTS_FAILED_TYPE = {
  type: 'FETCH_STUDENT_PARENTS_FAILED',
  payload: ERROR_TYPE
};
export const FETCH_STUDENT_PARENTS_FAILED = 'FETCH_STUDENT_PARENTS_FAILED';

export type FETCH_STUDENT_CHANGE_STOP_REQUESTS_STARTED_TYPE = {
  type: 'FETCH_STUDENT_CHANGE_STOP_REQUESTS_STARTED',
  payload: {
    id: number
  }
};
export const FETCH_STUDENT_CHANGE_STOP_REQUESTS_STARTED = 'FETCH_STUDENT_CHANGE_STOP_REQUESTS_STARTED';

export type FETCH_STUDENT_CHANGE_STOP_REQUESTS_SUCCESS_TYPE = {
  type: 'FETCH_STUDENT_CHANGE_STOP_REQUESTS_SUCCESS',
  payload: {
    entities: Array<CHANGE_STOP_REQUEST_TYPE>,
    order: Array<number>
  }
};
export const FETCH_STUDENT_CHANGE_STOP_REQUESTS_SUCCESS = 'FETCH_STUDENT_CHANGE_STOP_REQUESTS_SUCCESS';

export type FETCH_STUDENT_CHANGE_STOP_REQUESTS_FAILED_TYPE = {
  type: 'FETCH_STUDENT_CHANGE_STOP_REQUESTS_FAILED',
  payload: ERROR_TYPE
};
export const FETCH_STUDENT_CHANGE_STOP_REQUESTS_FAILED = 'FETCH_STUDENT_CHANGE_STOP_REQUESTS_FAILED';

export type FETCH_STUDENT_GATEWAYS_STARTED_TYPE = {
  type: 'FETCH_STUDENT_GATEWAYS_STARTED',
  payload: number
};
export const FETCH_STUDENT_GATEWAYS_STARTED = 'FETCH_STUDENT_GATEWAYS_STARTED';

export type FETCH_STUDENT_GATEWAYS_SUCCESS_TYPE = {
  type: 'FETCH_STUDENT_GATEWAYS_SUCCESS',
  payload: {
    id: number,
    gatewayUserActions: Array<number>
  }
};
export const FETCH_STUDENT_GATEWAYS_SUCCESS = 'FETCH_STUDENT_GATEWAYS_SUCCESS';

export type FETCH_STUDENT_GATEWAYS_FAILED_TYPE = {
  type: 'FETCH_STUDENT_GATEWAYS_FAILED',
  payload: ERROR_TYPE
};
export const FETCH_STUDENT_GATEWAYS_FAILED = 'FETCH_STUDENT_GATEWAYS_FAILED';

export type STUDENT_BOARDED_TYPE = {
  type: 'STUDENT_BOARDED',
  payload: {
    id: number,
    is_present: true
  }
};
export const STUDENT_BOARDED = 'STUDENT_BOARDED';

export type STUDENT_UNMARKED_TYPE = {
  type: 'STUDENT_UNMARKED',
  payload: {
    id: number,
    is_present: false
  }
};
export const STUDENT_UNMARKED = 'STUDENT_UNMARKED';

export type STUDENT_ROUTES_FETCH_STARTED_TYPE = {
  type: 'STUDENT_ROUTES_FETCH_STARTED',
  payload: number
};
export const STUDENT_ROUTES_FETCH_STARTED = 'STUDENT_ROUTES_FETCH_STARTED';

export type STUDENT_ROUTES_FETCH_SUCCEED_TYPE = {
  type: 'STUDENT_ROUTES_FETCH_SUCCEED',
  payload: {
    id: number,
    entities: {[number]: ROUTE_TYPE},
    order: Array<number>
  }
};
export const STUDENT_ROUTES_FETCH_SUCCEED = 'STUDENT_ROUTES_FETCH_SUCCEED';

export type STUDENT_ROUTES_FETCH_FAILED_TYPE = {
  type: 'STUDENT_ROUTES_FETCH_FAILED',
  payload: ERROR_TYPE
};
export const STUDENT_ROUTES_FETCH_FAILED = 'STUDENT_ROUTES_FETCH_FAILED';

export type ADD_STUDENT_CHANGE_STOP_REQUESTS_TYPE = {
  type: 'ADD_STUDENT_CHANGE_STOP_REQUESTS',
  payload: {
    id: number,
    changeStopRequests: Array<number>
  }
};
export const ADD_STUDENT_CHANGE_STOP_REQUESTS = 'ADD_STUDENT_CHANGE_STOP_REQUESTS';

export type STUDENT_ROUTES_UPDATED_TYPE = {
  type: 'STUDENT_ROUTES_UPDATED',
  payload: {
    id: number,
    entities: {[number]: ROUTE_TYPE},
    order: Array<number>
  }
};
export const STUDENT_ROUTES_UPDATED = 'STUDENT_ROUTES_UPDATED';

export type ADD_WEEKDAY_TO_STOP_TYPE = {
  type: 'ADD_WEEKDAY_TO_STOP',
  payload: {
    weekDay: number,
    studentId: number,
    routeStopId: number,
  }
};
export const ADD_WEEKDAY_TO_STOP = 'ADD_WEEKDAY_TO_STOP';

export type REMOVE_WEEKDAY_FROM_STOP_TYPE = {
  type: 'REMOVE_WEEKDAY_FROM_STOP',
  payload: {
    weekDay: number,
    studentId: number,
    routeStopId: number,
  }
};
export const REMOVE_WEEKDAY_FROM_STOP = 'REMOVE_WEEKDAY_FROM_STOP';

export type FETCH_ASSIGNED_STOPS_STARTED_TYPE = {
  type: 'FETCH_ASSIGNED_STOPS_STARTED',
  payload: {
    id: number
  }
};
export const FETCH_ASSIGNED_STOPS_STARTED = 'FETCH_ASSIGNED_STOPS_STARTED';

export type FETCH_ASSIGNED_STOPS_SUCCESS_TYPE = {
  type: 'FETCH_ASSIGNED_STOPS_SUCCESS',
  payload: Object
};

export const FETCH_ASSIGNED_STOPS_SUCCESS = 'FETCH_ASSIGNED_STOPS_SUCCESS';

export type FETCH_ASSIGNED_STOPS_FAILED_TYPE = {
  type: 'FETCH_ASSIGNED_STOPS_FAILED',
  payload: ERROR_TYPE
};
export const FETCH_ASSIGNED_STOPS_FAILED = 'FETCH_ASSIGNED_STOPS_FAILED';

export type UPDATE_STUDENT_STARTED_TYPE = {
  type: 'UPDATE_STUDENT_STARTED',
  payload: Object
};
export const UPDATE_STUDENT_STARTED = 'UPDATE_STUDENT_STARTED';

export type UPDATE_STUDENT_SUCCEED_TYPE = {
  type: 'UPDATE_STUDENT_SUCCEED',
  payload: STUDENT_TYPE
};
export const UPDATE_STUDENT_SUCCEED = 'UPDATE_STUDENT_SUCCEED';

export type UPDATE_STUDENT_FAILED_TYPE = {
  type: 'UPDATE_STUDENT_FAILED',
  payload: ERROR_TYPE,
}
export const UPDATE_STUDENT_FAILED = 'UPDATE_STUDENT_FAILED';

export type SAVE_STOP_ASSIGNATIONS_STARTED_TYPE = {
  type: 'SAVE_STOP_ASSIGNATIONS_STARTED',
  payload: {
    studentId: ID_TYPE,
    stopsSchedule: {[number]: Object},
    gatewaysSchedule: {[number]: Object},
  }
}
export const SAVE_STOP_ASSIGNATIONS_STARTED = 'SAVE_STOP_ASSIGNATIONS_STARTED';

export type SAVE_STOP_ASSIGNATIONS_SUCCEED_TYPE = {
  type: 'SAVE_STOP_ASSIGNATIONS_SUCCEED',
  payload: any
}
export const SAVE_STOP_ASSIGNATIONS_SUCCEED = 'SAVE_STOP_ASSIGNATIONS_SUCCEED';

export type SAVE_STOP_ASSIGNATIONS_FAILED_TYPE = {
  type: 'SAVE_STOP_ASSIGNATIONS_FAILED',
  payload: ERROR_TYPE
}
export const SAVE_STOP_ASSIGNATIONS_FAILED = 'SAVE_STOP_ASSIGNATIONS_FAILED';

export type ADD_STUDENT_PARENT_STARTED_TYPE = {
  type: 'ADD_STUDENT_PARENT_STARTED',
  payload: {
    idStudent: number,
    idParent: number,
  }
}
export const ADD_STUDENT_PARENT_STARTED = 'ADD_STUDENT_PARENT_STARTED';

export type ADD_STUDENT_PARENT_SUCCESS_TYPE = {
  type: 'ADD_STUDENT_PARENT_SUCCESS',
  payload: {
    id: number,
    parents: Array<number>
  }
}
export const ADD_STUDENT_PARENT_SUCCESS = 'ADD_STUDENT_PARENT_SUCCESS';

export type ADD_STUDENT_PARENT_FAILED_TYPE = {
  type: 'ADD_STUDENT_PARENT_FAILED',
  payload: ERROR_TYPE
}
export const ADD_STUDENT_PARENT_FAILED = 'ADD_STUDENT_PARENT_FAILED';

export type REMOVE_STUDENT_PARENT_STARTED_TYPE = {
  type: 'REMOVE_STUDENT_PARENT_STARTED',
  payload: {
    idStudent: number,
    idParent: number,
  }
}
export const REMOVE_STUDENT_PARENT_STARTED = 'REMOVE_STUDENT_PARENT_STARTED';

export type REMOVE_STUDENT_PARENT_SUCCESS_TYPE = {
  type: 'REMOVE_STUDENT_PARENT_SUCCESS',
  payload: {
    id: number,
    parents: Array<number>,
  }
}
export const REMOVE_STUDENT_PARENT_SUCCESS = 'REMOVE_STUDENT_PARENT_SUCCESS';

export type REMOVE_STUDENT_PARENT_FAILED_TYPE = {
  type: 'REMOVE_STUDENT_PARENT_FAILED',
  payload: ERROR_TYPE
}
export const REMOVE_STUDENT_PARENT_FAILED = 'REMOVE_STUDENT_PARENT_FAILED';

export type FETCH_STUDENT_CHANGE_REQUESTS_STARTED_TYPE = {
  type: 'FETCH_STUDENT_CHANGE_REQUESTS_STARTED',
  payload: {
    id: number,
  }
}
export const FETCH_STUDENT_CHANGE_REQUESTS_STARTED = 'FETCH_STUDENT_CHANGE_REQUESTS_STARTED';

export type FETCH_STUDENT_CHANGE_REQUESTS_SUCCESS_TYPE = {
  type: 'FETCH_STUDENT_CHANGE_REQUESTS_SUCCESS',
  payload: {
    id: number,
    change_requests: Array<string>
  }
}
export const FETCH_STUDENT_CHANGE_REQUESTS_SUCCESS = 'FETCH_STUDENT_CHANGE_REQUESTS_SUCCESS';

export type FETCH_STUDENT_CHANGE_REQUESTS_FAILED_TYPE = {
  type: 'FETCH_STUDENT_CHANGE_REQUESTS_FAILED',
  payload: ERROR_TYPE,
}
export const FETCH_STUDENT_CHANGE_REQUESTS_FAILED = 'FETCH_STUDENT_CHANGE_REQUESTS_FAILED';


export type STUDENTS_ACTION_TYPE =
  | STUDENTS_FETCH_STARTED_TYPE
  | ADD_WEEKDAY_TO_STOP_TYPE
  | REMOVE_STUDENT_PARENT_STARTED_TYPE
  | FETCH_STUDENT_CHANGE_REQUESTS_STARTED_TYPE
  | FETCH_STUDENT_CHANGE_REQUESTS_SUCCESS_TYPE
  | FETCH_STUDENT_CHANGE_REQUESTS_FAILED_TYPE
  | REMOVE_STUDENT_PARENT_SUCCESS_TYPE
  | REMOVE_STUDENT_PARENT_FAILED_TYPE
  | ADD_STUDENT_PARENT_STARTED_TYPE
  | ADD_STUDENT_PARENT_SUCCESS_TYPE
  | ADD_STUDENT_PARENT_FAILED_TYPE
  | FETCH_ASSIGNED_STOPS_STARTED_TYPE
  | FETCH_ASSIGNED_STOPS_SUCCESS_TYPE
  | FETCH_ASSIGNED_STOPS_FAILED_TYPE
  | STUDENTS_FETCH_SUCCEED_TYPE
  | FETCH_STUDENT_GATEWAYS_FAILED_TYPE
  | STUDENTS_FETCH_FAILED_TYPE
  | STUDENT_FETCH_STARTED_TYPE
  | STUDENT_FETCH_SUCCEED_TYPE
  | STUDENT_FETCH_FAILED_TYPE
  | STUDENT_SELECTED_TYPE
  | STUDENT_SELECTION_CLEARED_TYPE
  | STUDENT_DROPPED_TYPE
  | STUDENT_BOARDED_TYPE
  | STUDENT_UNMARKED_TYPE
  | STUDENT_ROUTES_FETCH_STARTED_TYPE
  | STUDENT_ROUTES_FETCH_SUCCEED_TYPE
  | STUDENT_ROUTES_FETCH_FAILED_TYPE
  | STUDENT_ROUTES_UPDATED_TYPE;



// WEBPACK FOOTER //
// ./src/scripts/types/students.js